import { render, staticRenderFns } from "./Newmoneypk.vue?vue&type=template&id=7c4c279a&scoped=true&"
import script from "./Newmoneypk.vue?vue&type=script&lang=js&"
export * from "./Newmoneypk.vue?vue&type=script&lang=js&"
import style0 from "./Newmoneypk.vue?vue&type=style&index=0&id=7c4c279a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4c279a",
  null
  
)

export default component.exports